module.exports = __webpack_public_path__ + "img/IR2.2fa21a1.jpg";